import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import ApexChart from "react-apexcharts";
import CustomToggle from "../../../../components/common/CustomToggle";
import { useGetClientTrendsQuery } from "../../../../redux/service/modules/sales";
import { useSelector } from "react-redux";
import Loader from "../../../../components/common/loader";
import NoDataAvailable from "../../../../components/common/NoDataAvailable";

const ActivityTrend = ({ appliedFilters, setRequiredFilters }) => {
  const dateRange = useSelector((state) => state.date);
  const [selectedValue, setSelectedValue] = useState("Analyst");
  const [dataLoading, setLoading] = useState(true);
  const {
    data: apiData,
    error,
    isLoading,
    refetch,
  } = useGetClientTrendsQuery({
    appliedFilters,
    startDate: dateRange?.startDate,
    endDate: dateRange?.endDate,
  });
  useEffect(() => {
    setRequiredFilters(["user"]);
  }, []);

  const labels = useRef({
    quarters_summary: [],
    user_summary: []
  })

  const [chartUserState, setUserChartState] = useState({
    series: [
      {
        name: "Market Share",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "line",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: [1, 2],
          color: "#8BDBCD",
          top: 5,
          left: 0,
          blur: 3,
          opacity: 1,
        },
      },
      markers: {
        fillColor: "#fff",
        colors: ["#fff", "#fff"],
        strokeColors: ["#8BDBCD", "#ED1C24", "#939598"],
        fillOpacity: 1,
        size: 4,
        strokeWidth: 3,
        shape: "circle",
      },
      colors: ["#8BDBCD", "#ED1C24", "#939598"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1, 2],
        formatter: function (val, opts) {
          return val;
        },
        textAnchor: "middle",
        distributed: false,
        offsetX: 0,
        offsetY: -8,
        style: {
          fontSize: "14px",
        },
        background: {
          enabled: false,
        },
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: "#000",
          opacity: 0.45,
        },
      },
      noData: {
        text: undefined,
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined
        }
      },
      xaxis: {
        labels: {
          formatter: function (value) {
          return labels.current['user_summary'][value - 1]
          }
        }
      },
      labels: [],
    },
  });
  const [chartQuarterState, setQuarterChartState] = useState({
    series: [
      {
        name: "Market Share",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "line",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: [1, 2],
          color: "#8BDBCD",
          top: 5,
          left: 0,
          blur: 3,
          opacity: 1,
        },
      },
      noData: {
        text: undefined,
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined
        }
      },
      markers: {
        fillColor: "#fff",
        colors: ["#fff", "#fff"],
        strokeColors: ["#8BDBCD", "#ED1C24", "#939598"],
        fillOpacity: 1,
        size: 4,
        strokeWidth: 3,
        shape: "circle",
      },
      colors: ["#8BDBCD", "#ED1C24", "#939598"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end",
        },
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1, 2],
        formatter: function (val, opts) {
          return val;
        },
        textAnchor: "middle",
        distributed: false,
        offsetX: 0,
        offsetY: -8,
        style: {
          fontSize: "14px",
        },
        background: {
          enabled: false,
        },
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: "#000",
          opacity: 0.45,
        },
      },
      xaxis: {
        labels: {
          formatter: function (value) {

          return labels.current['quarters_summary'][value - 1]

          }
        }
      },
      labels: [],
    },
  });

  useEffect(() => {
    setLoading(true);
    const mapping = {
      quarters_summary: setQuarterChartState,
      user_summary: setUserChartState,
    };
    const keys = ["quarters_summary", "user_summary"];
    const current_labels = {
      quarters_summary: [],
      user_summary: []
    };
    keys.forEach((key, dataIndex) => {
      const currentTotal = [];
      const qoqTotal = [];
      const yoyGrowth = [];
      
      apiData?.[key]?.forEach((data, index) => {
        currentTotal.push(data.current_total || 0);
        yoyGrowth.push(data.yoy_growth || 0);
        qoqTotal.push(data.qoq_growth || 0);
        const label = data.user_name || data.quarter || "-"
        current_labels[key].push(label);
      });
      if (apiData) {
        mapping[key]((chartState) => ({
          series: [
            {
              name: "Total Interaction",
              type: "column",
              data: currentTotal || [],
            },
            {
              name: "QoQ Growth %",
              type: "line",
              data: qoqTotal || [],
            },
            {
              name: "YoY Growth %",
              type: "line",
              data: yoyGrowth || [],
            },
          ],
          options: {
            ...chartState.options,
            // labels: labels || [],
          },
        }));
      }
      if (dataIndex === 1) {
        setLoading(false);
      }

    });
    labels.current =current_labels
  }, [apiData, selectedValue]);

  const onChange = (val) => {
    setSelectedValue(val);
  };

  return (
    <div style={{ minHeight: "500px" }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Box sx={{ width: "fit-content" }}>
          <CustomToggle
            options={["Analyst", "Interactions"]}
            onChange={onChange}
            selectedValue={selectedValue}
          />
        </Box>
      </div>
      <div
        style={{
          width: "90%",
          maxHeight: "700px",
          margin: "auto",
          maxWidth: "900px",
          display: selectedValue === "Analyst" ? "block" : "none",
        }}
      >
        { chartUserState?.series?.length && !isLoading && !dataLoading ? (
          <ApexChart
            options={chartUserState?.options || {}}
            series={chartUserState?.series || []}
            width="100%"
          />
        ) : dataLoading ? (
          <Loader isFullPage={false} />
        ) : !apiData?.user_summary?.length ? (
          <NoDataAvailable />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          width: "90%",
          maxHeight: "700px",
          margin: "auto",
          maxWidth: "900px",
          display: selectedValue !== "Analyst" ? "block" : "none",
        }}
      >


        {chartQuarterState?.series?.length && !isLoading && !dataLoading ? (
          <ApexChart
            options={chartQuarterState?.options || {}}
            series={chartQuarterState?.series || []}
            width="100%"
          />
        ) : dataLoading ? (
          <Loader isFullPage={false} />
        ) : !apiData?.quarters_summary?.length ? (
          <NoDataAvailable />
        ) : (
          ""
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default ActivityTrend;
